// extracted by mini-css-extract-plugin
export var colorSquare = "_r0-0";
export var danger = "_r0-5";
export var lightPink = "_r0-8";
export var neutralBlue = "_r0-7";
export var neutralYellow = "_r0-6";
export var normal = "_r0-1";
export var primary = "_r0-2";
export var primaryLight = "_r0-3";
export var solidBlack = "_r0-g";
export var solidGreen = "_r0-b";
export var solidLightBlue = "_r0-d";
export var solidNavy = "_r0-c";
export var solidOrange = "_r0-f";
export var solidPink = "_r0-e";
export var solidRed = "_r0-9";
export var solidYellow = "_r0-a";
export var success = "_r0-4";